import { SectionContainer } from 'components/DetailsView/Section';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TotemTrashButton } from 'components/TotemTrashButton';
import { FunctionComponent, useState } from 'react';
import styled from 'styled-components';
import { AddArrangementPopupForCreation } from './components/AddArrangementPopupForCreation';

export type ArrangementSelection = {
    arrangementId: string;
    arrangementName: string;
    stockMax: number;
};

type ProductArrangementCreationSectionProps = {
    selectedArrangements: ArrangementSelection[];
    onArrangementsChange: (arrangements: ArrangementSelection[]) => void;
};

export const ProductArrangementCreationSection: FunctionComponent<ProductArrangementCreationSectionProps> = ({
    selectedArrangements,
    onArrangementsChange,
}) => {
    const [showAddPopup, setShowAddPopup] = useState(false);

    const onRemoveArrangement = (arrangementId: string) => {
        onArrangementsChange(selectedArrangements.filter((a) => a.arrangementId !== arrangementId));
    };

    const onAddArrangement = (arrangement: ArrangementSelection) => {
        onArrangementsChange([...selectedArrangements, arrangement]);
    };

    const getContent = () => {
        if (!selectedArrangements.length) {
            return <EmptyMessage>Aucune gamme sélectionnée. Au moins une gamme est requise.</EmptyMessage>;
        }

        return (
            <TableContainer>
                <table>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Stock max</th>
                            <th> </th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...selectedArrangements]
                            .sort((a, b) => a.arrangementName.localeCompare(b.arrangementName))
                            .map((arrangement) => (
                                <tr key={arrangement.arrangementId}>
                                    <Name>{arrangement.arrangementName}</Name>
                                    <td>{arrangement.stockMax}</td>
                                    <td>
                                        <TotemTrashButton
                                            onClick={() => onRemoveArrangement(arrangement.arrangementId)}
                                        />
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </TableContainer>
        );
    };

    const alreadySelectedIds = selectedArrangements.map((a) => a.arrangementId);

    return (
        <SectionContainer title="Gammes de produit" isInitiallyOpen>
            <Container>
                {getContent()}
                <TotemPrimaryButton onClick={() => setShowAddPopup(true)} type="button">
                    Ajouter à une gamme de produit
                </TotemPrimaryButton>
                <AddArrangementPopupForCreation
                    isOpen={showAddPopup}
                    setIsOpen={setShowAddPopup}
                    alreadySelectedIds={alreadySelectedIds}
                    onAdd={onAddArrangement}
                />
            </Container>
        </SectionContainer>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const EmptyMessage = styled.p`
    font-style: italic;
`;

const TableContainer = styled.div`
    display: flex;

    table {
        border-spacing: 0;
        border-collapse: collapse;
        color: ${({ theme }) => theme.textColor};
        th,
        td {
            text-align: left;
            border: 1px solid ${({ theme }) => theme.lightBorderColor};
            padding: 16px;
        }
    }
`;

const Name = styled.td`
    font-weight: bold;
`;
